import type { RouteRecordRaw } from 'vue-router';

export const cDOCUMENTACAO_ROUTES = {
  Documentacao: {
    name: 'Documentacao',
    path: '/documentacao',
    component: () => import('@/modules/documentacao/Documentacao.vue'),
  },

  Apresentacao: {
    name: 'ApresentacaoDocumentacao',
    path: 'apresentacao',
    component: () => import('@/modules/documentacao/apresentacao/DocApresentacaoProduto.vue'),
  },

  Funcionamento: {
    name: 'FuncionamentoDocumentacao',
    path: 'funcionamento',
    component: () => import('@/modules/documentacao/funcionamento/DocFuncionamento.vue'),
  },

  Implantacao: {
    name: 'Implantacao',
    path: 'implantacao',
    component: () => import('@/modules/documentacao/implantacao/DocImplantacao.vue'),
  },

  RoadMap: {
    name: 'RoadMap',
    path: 'roadmap',
    component: () => import('@/modules/documentacao/roadmap-produto/RoadMapProduto.vue'),
  },
};

export const rotasDocumentacao: Array<RouteRecordRaw> = [
  {
    path: cDOCUMENTACAO_ROUTES.Documentacao.path,
    name: cDOCUMENTACAO_ROUTES.Documentacao.name,
    component: cDOCUMENTACAO_ROUTES.Documentacao.component,
    meta: { requiresAuth: false },
    children: [
      {
        name: cDOCUMENTACAO_ROUTES.Apresentacao.name,
        path: cDOCUMENTACAO_ROUTES.Apresentacao.path,
        component: cDOCUMENTACAO_ROUTES.Apresentacao.component,
      },

      {
        name: cDOCUMENTACAO_ROUTES.Funcionamento.name,
        path: cDOCUMENTACAO_ROUTES.Funcionamento.path,
        component: cDOCUMENTACAO_ROUTES.Funcionamento.component,
      },

      {
        name: cDOCUMENTACAO_ROUTES.Implantacao.name,
        path: cDOCUMENTACAO_ROUTES.Implantacao.path,
        component: cDOCUMENTACAO_ROUTES.Implantacao.component,
      },

      {
        name: cDOCUMENTACAO_ROUTES.RoadMap.name,
        path: cDOCUMENTACAO_ROUTES.RoadMap.path,
        component: cDOCUMENTACAO_ROUTES.RoadMap.component,
      },
    ],
  },
];
